module.exports = __webpack_public_path__ + "static/img/geotap-game-indie-prize-finalist.ddc133c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/laurels/geotap-game-indie-prize-finalist.png
// module id = kfK6
// module chunks = 0